export default {
  history: [],
  pending: [],
  segments: [],
  deviceCount: 0,
}
